import { TrendingUp, TrendingDown, Minus, ChevronLeft } from 'lucide-react';

export default function KpiCard({ title, value, subtitle, trendPct, icon: Icon, iconColor = 'text-primary', iconBg = 'bg-primary/10', onClick, to }) {
  const trendUp = trendPct > 0;
  const trendDown = trendPct < 0;
  const TrendIcon = trendUp ? TrendingUp : trendDown ? TrendingDown : Minus;
  const trendColor = trendUp ? 'text-emerald-600' : trendDown ? 'text-red-500' : 'text-muted-foreground';
  const clickable = !!(onClick || to);

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div
      onClick={handleClick}
      className={`bg-card border border-border rounded-2xl p-4 flex flex-col gap-3 shadow-sm relative transition-all duration-200
        ${clickable ? 'cursor-pointer hover:border-primary hover:shadow-md hover:-translate-y-0.5 active:scale-[0.98]' : ''}`}
    >
      {clickable && (
        <ChevronLeft className="absolute top-3 left-3 w-3.5 h-3.5 text-primary opacity-50" />
      )}
      <div className="flex items-start justify-between">
        <div className={`w-10 h-10 ${iconBg} rounded-xl flex items-center justify-center flex-shrink-0`}>
          <Icon className={`w-5 h-5 ${iconColor}`} />
        </div>
        {trendPct !== undefined && (
          <div className={`flex items-center gap-1 text-xs font-semibold ${trendColor}`}>
            <TrendIcon className="w-3 h-3" />
            {Math.abs(trendPct).toFixed(1)}%
          </div>
        )}
      </div>

      <div>
        <p className="text-xs text-muted-foreground font-medium mb-0.5">{title}</p>
        <p className="text-2xl font-black text-foreground leading-tight">{value}</p>
        {subtitle && <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>}
      </div>
    </div>
  );
}